module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_9005.dd463a8b.png";